<template>
	<div id="app">
		<div class="app-bg"></div>
		<div id="view">
			<router-view/>
		</div>
		<div class="header-bg"></div>
		<div class="nav">
			<a href="https://afisha.ru" target="_blank" @click="shareClick('afisha')">
				<img src="@/assets/logo_afisha.png">
			</a>
			<a
				href="https://www.borjomi.com/ru/borjoming/?utm_source=afisha&utm_medium=special_project&utm_content=landing&utm_campaign=RU-2018-12-borjomi-power-of-volcano"
				target="_blank"
				@click="shareClick('afisha')"
			>
				<img src="@/assets/logo_borjomi.png">
			</a>
		</div>
		<uiShares/>
	</div>
</template>

<script>
import uiShares from '@/components/uiShares'

export default {
	components: {
		uiShares,
	},
	methods: {
		shareClick(type) {
			ga('send', 'event', 'logo', type)
		},
	},
}
</script>

<style lang="less">
body {
	margin: 0;
	padding: 0;
	outline: none;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: 'Roboto Condensed', sans-serif;
}
a,
footer,
header,
img,
nav,
section {
	display: block;
}
.clearfix:after {
	content: '';
	display: table;
	clear: both;
}

#app {
	width: 100vw;
	height: 100vh;
	text-align: center;
	color: #fff;
	position: fixed;
	overflow-x: hidden;
}

.app-bg {
	width: 100%;
	height: 100%;
	background-image: url('./assets/main.jpg');
	background-size: cover;
	position: fixed;
}

#view {
	width: 100vw;
	height: 100vh;
	position: absolute;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
}

.header-bg {
	width: 100%;
	height: 87px;
	position: fixed;
	top: 0;
	left: 0;
	background-image: url('./assets/header.png');
	background-repeat: no-repeat;
	background-position: top right;
	z-index: 100;
}
.nav {
	width: calc(100% - 80px);
	padding: 0 40px;
	top: 30px;
	position: fixed;
	display: flex;
	justify-content: space-between;
	align-items: center;
	z-index: 200;

	img {
		width: 80px;
	}
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	.header-bg {
		background-size: cover;
		background-position: center center;
	}

	.nav {
		width: calc(100% - 20px);
		top: 15px;
		padding: 0 10px;

		img {
			width: 60px;
		}
	}
}
</style>
